/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>2 - Индикатор загрузки</h2>
    <p className={styles.description}>
      Пока ждем ответа на HTTP-запрос, показываем идтикатор загрузки. Как только пришел ответ, прячем индикатор. Для
      этого на старте запроса ставим <code className={styles.code}>isLoading</code> в{' '}
      <code className={styles.code}>true</code>, а при успешном ответе или ошибке в{' '}
      <code className={styles.code}>false</code>.
    </p>
    <CopyBlock
      text={`/* ... */

class App extends Component {
  state = {
    articles: [],
    isLoading: false,
  };

  componentDidMount() {
    this.setState({ isLoading: true });

    axios
      .get('https://hn.algolia.com/api/v1/search?query=react')
      .then(response => {
        this.setState({
          articles: response.data.hits,
          isLoading: false,
        });
      });
  }

  /* ... */
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      В методе <code className={styles.code}>render</code> по условию возвращаем разметку. Если данные загружаеются,
      показываем лоадер, в противном случае список с результатами.
    </p>
    <CopyBlock
      text={`/* ... */

class App extends Component {
  /* ... */

  render() {
    const { articles, isLoading } = this.state;

    return isLoading ? <p>Loading...</p> : <ArticleList articles={articles} />;
  }
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      Индикатор загрузки может быть чем угодно, от простого текста или спиннера, до кастомного компонента, например{' '}
      <a
        className={styles.link}
        href="https://github.com/danilowoz/react-content-loader"
        target="_blank"
        rel="noopener noreferrer"
      >
        react-content-loader
      </a>
      .
    </p>
  </section>
))
